import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { servicesData } from "../assets/services";
import { Service } from "../global/types";
import ServicesCard from "../components/ServicesCard";

export default function ParticipationPage() {
    const [partGovernmentArray, setPartGovernmentArray] = useState<Service[]>([]);
    const [partEuropeanArray, setPartEuropeanArray] = useState<Service[]>([]);
    const [partIndependentsArray, setPartIndependentsArray] = useState<Service[]>([]);

    const getPartGovernment = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΣυμμετοΚυβερνητικοί Οργανισμοί");

    const getPartEuropean = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΣυμμετοΕυρωπαϊκοί Οργανισμοί");

    const getPartIndependents = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΣυμμετοΑνεξάρτητες αρχές");

    useEffect(() => {
        setPartGovernmentArray(getPartGovernment());
    }, []);

    useEffect(() => {
        setPartEuropeanArray(getPartEuropean());
    }, []);

    useEffect(() => {
        setPartIndependentsArray(getPartIndependents());
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const tabColor = useColorModeValue("primary", "light");

    return (
        <Box>
            <Tabs variant="enclosed" colorScheme={tabColor}>
                <TabList flex="1">
                    <Tab fontWeight="bold">Κυβερνητικοί Οργανισμοί</Tab>
                    <Tab fontWeight="bold">Ευρωπαϊκοί Οργανισμοί</Tab>
                    <Tab fontWeight="bold">Ανεξάρτητες Αρχές</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        {partGovernmentArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {partEuropeanArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {partIndependentsArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}